import Vue from "vue";
// import router from "../../router";

//set Headers payload
const authHeader = process.env.VUE_APP_REQUEST_HEADER;
const headers = {};
headers[authHeader] = process.env.VUE_APP_HUB_API_KEY;

export default {
    namespaced: true,
    state: () => ({
      loadingCompanyDetails: false,
      loadingAddContact: false,
    }),
    mutations: {
      setLoadingCompanyDetails(state, isLoading) {
        state.loadingCompanyDetails = isLoading;
      },
      setLoadingAddContact(state, isLoading) {
        state.loadingAddContact = isLoading;
      }
    },
    actions: {
      async fetchCompanyDetailsFromAnaf({ commit }, cui) {
        commit("setLoadingCompanyDetails", true);
        const urlParams = {
          cui: cui,
        };
        let companyDetails = null;
        await Vue.http.get(process.env.VUE_APP_HUB_API_HOST + "api/anaf/company", {
            headers: headers,
            params: urlParams,
          })
          .then(function (response) {
            companyDetails = response.body.found[0];
            commit("setLoadingCompanyDetails", false);
          })
          .catch(function (error) {
            console.error(error.body);
            commit("setLoadingCompanyDetails", false);
          });
        return companyDetails;
      },
      async addContact( { commit }, contact) {
        commit("setLoadingAddContact", true);

        const url = process.env.VUE_APP_HUB_API_HOST + "api/contacts/add";
        try {
          const response = await Vue.http.post(url, contact, { headers: headers });
          commit("setLoadingAddContact", false);
          return response.data;
        } catch (error) {
          console.error(error);
          commit("setLoadingAddContact", false);
          throw error;
        }

      }
    }
}